import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(
          _vm._s(_vm.$t("frases.productize_mi_usecase")) +
            ": " +
            _vm._s(_vm.$t("menu.audience"))
        ),
      ]),
      _c(VBreadcrumbs, { staticClass: "pa-0 py-2 text--black" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("attributes.sandbox.productize_model_desc")) + " "
        ),
      ]),
      _vm._t("default"),
      _c(
        VCard,
        { staticClass: "audiencias" },
        [
          _c(
            VCardText,
            [
              _c(
                VForm,
                {
                  ref: "form",
                  attrs: { "lazy-validation": "", readonly: !_vm.edit },
                  model: {
                    value: _vm.valid,
                    callback: function ($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid",
                  },
                },
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        {
                          staticClass: "form-row row--dense fit_content",
                          attrs: { cols: "6", dense: "" },
                        },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "form_attrs_productize_usecase.use_case"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            VIcon,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "pointer",
                                                  attrs: { small: "" },
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [_vm._v("icon-help")]
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("descripcion.use_case"))
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "8" } },
                            [
                              _c(VSelect, {
                                attrs: {
                                  outlined: _vm.edit,
                                  filled: !_vm.edit,
                                  "hide-details": "auto",
                                  dense: "",
                                  items: _vm.items,
                                  "item-text": "business_name",
                                  "return-object": "",
                                  required: "",
                                  rules: _vm.rules.useCase,
                                },
                                on: { change: _vm.onUseCaseSelected },
                                model: {
                                  value: _vm.item,
                                  callback: function ($$v) {
                                    _vm.item = $$v
                                  },
                                  expression: "item",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "form_attrs_productize_usecase.segment"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            VIcon,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "pointer",
                                                  attrs: { small: "" },
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [_vm._v("icon-help")]
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("descripcion.segment"))
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "8" } },
                            [
                              _c(VSelect, {
                                attrs: {
                                  outlined: _vm.edit,
                                  filled: !_vm.edit,
                                  placeholder: _vm.$t(
                                    "attributes.placeholder.input_segment"
                                  ),
                                  "hide-details": "auto",
                                  dense: "",
                                  rules: _vm.rules.segment,
                                  items: _vm.segments,
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataToExport.segment,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataToExport, "segment", $$v)
                                  },
                                  expression: "dataToExport.segment",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "form_attrs_productize_usecase.process_date"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            VIcon,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "pointer",
                                                  attrs: { small: "" },
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [_vm._v("icon-help")]
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "descripcion.segment_process_date"
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "8" } },
                            [
                              _c(VSelect, {
                                attrs: {
                                  outlined: _vm.edit,
                                  filled: !_vm.edit,
                                  placeholder: _vm.$t(
                                    "attributes.placeholder.select_process_date"
                                  ),
                                  "hide-details": "auto",
                                  dense: "",
                                  items: _vm.processDates,
                                  rules: _vm.rules.segmentProcessDate,
                                  "append-icon": "mdi-calendar",
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataToExport.process_date,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataToExport,
                                      "process_date",
                                      $$v
                                    )
                                  },
                                  expression: "dataToExport.process_date",
                                },
                              }),
                            ],
                            1
                          ),
                          false
                            ? [
                                _c(
                                  VCol,
                                  { attrs: { cols: "4" } },
                                  [
                                    _c(
                                      VSubheader,
                                      { staticClass: "font-weight-bold" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "form_attrs_productize_usecase.script"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      VTooltip,
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    VIcon,
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "pointer",
                                                          attrs: { small: "" },
                                                        },
                                                        "v-icon",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [_vm._v("icon-help")]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3609917066
                                        ),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "descripcion.attrs_script_sql"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  VCol,
                                  { attrs: { cols: "8" } },
                                  [
                                    _c(VFileInput, {
                                      attrs: {
                                        accept: ".txt,.sql",
                                        outlined: _vm.edit,
                                        filled: !_vm.edit,
                                        placeholder: _vm.$t(
                                          "attributes.placeholder.attach_script_sql_txt"
                                        ),
                                        "hide-details": "auto",
                                        dense: "",
                                        "show-size": "",
                                        counter: "",
                                        required: "",
                                        "prepend-icon": "",
                                        "append-icon": "mdi-paperclip",
                                      },
                                      model: {
                                        value: _vm.dataToExport.script,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dataToExport,
                                            "script",
                                            $$v
                                          )
                                        },
                                        expression: "dataToExport.script",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _c(VCol, { attrs: { cols: "6" } }, [
                        _vm.hasIDSInfo
                          ? _c(
                              "div",
                              {
                                key: _vm.keyPrevisualize,
                                staticClass: "visualization",
                              },
                              [
                                _c("total-match-component", {
                                  attrs: {
                                    title: _vm.translate(
                                      "frases.identified_ids"
                                    ),
                                    value: _vm.IDSInfo.records,
                                  },
                                }),
                                _c("total-match-component", {
                                  attrs: {
                                    title: _vm.translate(
                                      "frases.duplicated_ids"
                                    ),
                                    value: _vm.IDSInfo.duplicated,
                                  },
                                }),
                                _c("total-match-component", {
                                  attrs: {
                                    title: _vm.translate(
                                      "frases.not_identified_ids"
                                    ),
                                    value: _vm.IDSInfo["not-found"],
                                    help: _vm.translate(
                                      "attributes.attributes_description.not_identified_ids"
                                    ),
                                  },
                                }),
                                _vm.IDSInfo.duplicated &&
                                _vm.IDSInfo.duplicated > 0
                                  ? _c(
                                      VAlert,
                                      {
                                        staticClass: "mt-2",
                                        attrs: {
                                          border: "bottom",
                                          "colored-border": "",
                                          type: "warning",
                                          elevation: "2",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.warningMessage) + " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(VCardActions, [
            _c(
              "div",
              { staticClass: "col-6 p-0 flex text-center" },
              [
                _c(
                  VBtn,
                  {
                    staticClass: "default mr-1",
                    attrs: { outlined: "" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.push({ name: "productize_model" })
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                ),
                _c(
                  VBtn,
                  {
                    staticClass: "mr-1",
                    attrs: { color: "secondary", outlined: "" },
                    on: { click: _vm.onValidate },
                  },
                  [_vm._v(_vm._s(_vm.$t("btns.preview")))]
                ),
                _c(
                  VBtn,
                  {
                    staticClass: "primary mr-1",
                    attrs: { disabled: !_vm.isValidated },
                    on: { click: _vm.onSubmit },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.save")))]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }